import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./directormessage.scss";

function DirectorMessage() {
  return (
    <section className="director-section">
      <Container className="py-5">

        {/* Section Header */}
        <div className="text-center mb-5">
          <h2 className="section-title">Director's Message</h2>
          <p className="section-subtitle">
            Leadership vision that drives innovation and excellence
          </p>
        </div>

        <Row className="g-4">

          {/* Director 1 */}
          <Col md={6}>
            <Card className="director-card">
              <Card.Body>

                <div className="director-info">
                  <img
                    src="/images/personIcon01.png"
                    alt="Director"
                    className="director-img"
                  />
                  <div>
                    <h5 className="director-name">Mr. Ashok Narute</h5>
                    <span className="director-designation">
                      Managing Director
                    </span>
                  </div>
                </div>

                <p className="director-message" style={{ textAlign:"justify" }}>
                  At UIPlus Technologies, our mission is to deliver innovative,
                  scalable, and reliable digital solutions that empower
                  businesses to grow and succeed in the digital era. We believe
                  in long-term partnerships, transparency, and quality-driven
                  development.
                </p>

              </Card.Body>
            </Card>
          </Col>

          {/* Director 2 */}
          <Col md={6}>
            <Card className="director-card">
              <Card.Body>

                <div className="director-info">
                  <img
                    src="/images/personIcon02.png"
                    alt="Director"
                    className="director-img"
                  />
                  <div>
                    <h5 className="director-name">Mrs. Priyanka Jadhav</h5>
                    <span className="director-designation">
                      Managing Director
                    </span>
                  </div>
                </div>

                <p className="director-message" style={{ textAlign:"justify" }}>
                  Technology is at the core of everything we do. Our focus is on
                  building secure, high-performance applications using modern
                  frameworks and best practices to ensure our clients stay ahead
                  in a competitive digital landscape.
                </p>

              </Card.Body>
            </Card>
          </Col>

        </Row>

      </Container>
    </section>
  );
}

export default DirectorMessage;
